export default "__VITE_ASSET__C_3_Xr0q__"